var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',{staticClass:"page-box",attrs:{"background":"","current-page":_vm.childMsg.currentPage,"page-sizes":[10, 20, 30, 40],"page-size":_vm.childMsg.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.childMsg.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db8ce33c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
// module id = null
// module chunks = 